var map = {
	"./augmented-reality.png": 482,
	"./certificate.png": 1441,
	"./check.png": 5644,
	"./download-icon.png": 9541,
	"./location.png": 3677,
	"./notes.png": 7160,
	"./star.png": 9649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5421;